<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Faq</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CInput
              label="Question"
              placeholder="Enter Faq Question"
              v-model="Faq.question"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea
              label="Answer"
              placeholder="Enter Faq Answer"
              v-model="Faq.answer"
          />
        </CCol>
      </CRow>

    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle"/>
        Update Faq
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "FaqEdit",
  data() {
    return {
      Faq: {},
      img_url: "",
      categories: [],
    };
  },
  created() {
    this.getFaq();

  },
  methods: {
    getFaq() {
      this.$axios
          .get(`${ADMIN_URL}/faqs/${this.$route.params.id}`)
          .then((response) => {
            console.log(response.data);
            this.Faq = response.data.data;

          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },



    onSubmit() {
      let currentObj = this;
      
      // Don't manually set Content-Type - axios will set it automatically with boundary
      const config = {
        headers: {
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("question", this.Faq.question || "");
      formData.append("answer", this.Faq.answer || "");

      // Debug: Log FormData contents properly
      console.log("Form Data:");
      console.log("Question:", this.Faq.question);
      console.log("Answer:", this.Faq.answer);
      
       console.log(formData);

      this.$axios
          .post(`${ADMIN_URL}/faqs/${this.$route.params.id}`, formData, config)
          .then((response) => {
            currentObj.success = response.data.success;
            this.$swal("Success", response.data.message, "success");
            this.$router.go(0); // Better than window.location.reload()
          })
          .catch((error) => {
            console.log("Error details:", error.response);
            currentObj.output = error;
            const errorMessage = error.response?.data?.message || error.response?.message || error.message || "An error occurred";
            this.$swal("Error", errorMessage, "error");
          });
    },
  },
};
</script>

<style scoped>
</style>
